import { logger, safeError } from '../../../../utils/logger';
import React, { useState, useEffect, useRef } from 'react';
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { ReporteService } from '../../../../services/ReporteService';
import { Spinner, Alert } from 'react-bootstrap';
import { Breadcrumbs } from '../../../Home/Breadcrumb';
import { useAuth } from '../../../../hooks/useAuth'; // 1. Importar useAuth
import { ConsultasInteligentes } from '../../ConsultasInteligentes';


export const ReporteGestion = () => {
  const dashboardRef = useRef<HTMLDivElement>(null);
  const [dashboardUrl, setDashboardUrl] = useState<string | null>(null);
  const [embeddingContext, setEmbeddingContext] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const { getUsuarioLogueado } = useAuth(); // 2. Obtener el usuario del contexto
    const { id } = getUsuarioLogueado();

  // 1. Obtener la URL del Backend
  useEffect(() => {
    const fetchUrl = async () => {
      try {
        setLoading(true);
        const data = await ReporteService.getUrlReporteGestion(id);
        if (data && data.embedUrl) {
          setDashboardUrl(data.embedUrl);
        } else {
          setError("No se recibió una URL válida para el reporte.");
        }
      } catch (err) {
        setError("Error al conectar con el servicio de reportes.");
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, []);

  // 2. Crear el contexto de Embedding cuando tenemos la URL
  useEffect(() => {
    if (dashboardUrl) {
      const createContext = async () => {
        try {
          const context = await createEmbeddingContext();
          setEmbeddingContext(context);
        } catch (err) {
          logger.error("Error creando contexto de embedding:", safeError(err));
        }
      };
      createContext();
    }
  }, [dashboardUrl]);

  // 3. Incrustar el Dashboard cuando el contexto está listo
  useEffect(() => {
    if (embeddingContext && dashboardRef.current && dashboardUrl) {
      const embed = async () => {
        const options = {
          url: dashboardUrl,
          container: dashboardRef.current,
          height: "100%",
          width: "100%",
          scrolling: "no",
          locale: "es-ES", // Opcional: Configurar idioma
          footerPaddingEnabled: true,
        };

        await embeddingContext.embedDashboard(options);
      };
      embed();
    }
  }, [embeddingContext, dashboardUrl]);

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          <Breadcrumbs
            title={'Reportes de Gestión'}
            titlePage={'Reportes'}
          />

          <div className="row">
            <div className="col-12">
              <div className="card" style={{ minHeight: '80vh' }}>
                <div className="card-body h-100">

                  {/* Layout de dos paneles: dashboard (izq) + chat Q&A (der) */}
                  <div
                    style={{
                      display: 'flex',
                      gap: '10px',
                      height: 'calc(100vh - 200px)',
                      width: '100%',
                    }}
                  >
                    {/* Panel izquierdo: dashboard */}
                    <div style={{ flex: '1 1 auto', minWidth: 0, position: 'relative' }}>
                      {loading && (
                        <div className="text-center mt-5">
                          <Spinner animation="border" variant="primary" />
                          <p className="mt-2">Cargando reporte...</p>
                        </div>
                      )}

                      {error && (
                        <Alert variant="danger">
                          {error}
                        </Alert>
                      )}

                      {/* Contenedor del Dashboard */}
                      <div
                        ref={dashboardRef}
                        style={{
                          height: '100%',
                          width: '100%',
                          display: (loading || error) ? 'none' : 'block'
                        }}
                      />
                    </div>

                    {/* Panel derecho: chat Q&A */}
                    <div style={{ flex: '0 0 400px', minWidth: '350px', maxWidth: '500px' }}>
                      <ConsultasInteligentes />
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};